const currencyFields = [
    ['PurchasePrice', 'Purchase Price'],
    ['SalesTax', 'Sales Tax'],
    ['TotalCost', 'Total Cost'],
    ['TradeBoatEquity', 'Trade Boat Equity'],
    ['CashDownPayment', 'Cash Down Payment'],
    ['LoanAmount', 'Loan Amount']
];

function normalizeCurrency(value) {
    return String(value == null ? '' : value).trim()
        .replace(/^US\s*\$/i, '$').replace(/\$/g, '').replace(/,/g, '').trim();
}

export function parseApplicationCurrency(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : NaN;
    if (value == null || String(value).trim() === '') return 0;
    const normalized = normalizeCurrency(value);
    if (!/^-?(?:\d+(?:\.\d{0,2})?|\.\d{1,2})$/.test(normalized)) return NaN;
    const amount = Number(normalized);
    return Number.isFinite(amount) ? amount : NaN;
}

export function formatApplicationCurrency(value) {
    if (value == null || String(value).trim() === '') return '';
    const amount = parseApplicationCurrency(value);
    // Keep invalid text available for correction instead of formatting it as NaN.
    if (!Number.isFinite(amount)) return String(value);
    if (typeof value === 'number') {
        return new Intl.NumberFormat('en-US', {
            style: 'currency', currency: 'USD', minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }
    // Preserve the decimal portion while the user is typing, including a trailing dot.
    const normalized = normalizeCurrency(value);
    const parts = normalized.split('.');
    const whole = Number(parts[0] || 0);
    const formatted = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD', minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(normalized.startsWith('-') && whole === 0 ? -0 : whole);
    return formatted + (parts.length > 1 ? '.' + parts[1] : '');
}

export function invalidApplicationCurrencyFields(state) {
    return currencyFields.filter(([key]) =>
        !Number.isFinite(parseApplicationCurrency(state[key])))
        .map(([, label]) => label + ' must be a valid amount');
}

export function applicationCurrencyPayload(state) {
    const payload = { ...state };
    currencyFields.forEach(([key]) => {
        if (state[key] != null && String(state[key]).trim() !== '') {
            payload[key] = formatApplicationCurrency(parseApplicationCurrency(state[key]));
        }
    });
    return payload;
}
